import React, { useState, useEffect, useRef } from "react";

const TypewriterText = ({ text, speed = 10, onFinish, onClickFinish }) => {
	const [displayedText, setDisplayedText] = useState("");
	const hasAnimated = useRef(false);
	const [animationFinished, setAnimationFinished] = useState(false);

	useEffect(() => {
		// Prevent animation from restarting if text hasn't changed
		if (hasAnimated.current && displayedText === text) return;

		setDisplayedText("");
		setAnimationFinished(false);
		hasAnimated.current = true;
		let i = 0;

		const interval = setInterval(() => {
			if (i < text.length) {
				setDisplayedText(text.slice(0, i + 1));
				i++;
			} else {
				clearInterval(interval);
				setAnimationFinished(true);
				if (onFinish) {
					setTimeout(() => {
						onFinish();
					}, 1000);
				}
			}
		}, speed);

		return () => clearInterval(interval);
	}, [text, speed, onFinish]);

	return (
		<>
			<p className="">{displayedText}</p>
			{onClickFinish && animationFinished && (
				<button
					className="justify-self-end text-[#fbb554]"
					onClick={onClickFinish}
				>
					OK
				</button>
			)}
		</>
	);
};

export default TypewriterText;
